import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { doBootstrapOnboarding } from '../../actions'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile/operations'
import { V6_VERIFICATION_PAGE } from '../../pages'
import { doFinishOnboarding } from '../actions'

export const doSaveAndRedirect = fields => async (dispatch, getState) => {
  const companyFields = {
    whyGroove: fields.whyGroove,
    numberOfEmployees: fields.numberOfEmployees,
  }

  await dispatch(doUpdateCompanyProfile(companyFields))
  // HACK (jscheel): Because updating the company profile can change the
  // subdomain, we need to get the new subdomain back. This really should
  // come from the backend response, but in the interest of time, just doing
  // an extra request here to get this out.
  await dispatch(doBootstrapOnboarding())
  const { confirmationRequired } = selectCurrentUser(getState())

  if (confirmationRequired) {
    return dispatch({
      type: V6_VERIFICATION_PAGE,
    })
  }
  return dispatch(doFinishOnboarding())
}
